"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWatchableMap = exports.createWatchableFunction = void 0;
/*
  Takes a function and returns a [patchedFunctionWithSameSignature, subscribeToPatchedFunction] tuple.
  Listener callbacks are called with the same params passed into the patched function.
  The subscribe function returns an unsubscribe function.
  The original method is called before the subscribers and the patched function completes after all subscribers.
  Subscribers are called in a try-catch to ensure all subscribers are called.
*/
function createWatchableFunction(fn) {
    var callbacks = new Set();
    var subscribe = function (callback) {
        callbacks.add(callback);
        // Returns unsubscribe function
        return function () { return callbacks.delete(callback); };
    };
    // Needs to use the `function` keyword to allow setting `this`.
    function patchedFunction() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // Call original function using the correct `this` and params.
        var result = fn.apply(this, args);
        callbacks.forEach(function (callback) {
            try {
                callback.apply(void 0, __spreadArray([], __read(args), false));
            }
            catch (error) {
                // Only logging the errors. Maybe we should do more.
                console.error(error);
            }
        });
        // Return result from original function.
        return result;
    }
    // `as const` signifies a tuple type instead of an array type.
    return [patchedFunction, subscribe];
}
exports.createWatchableFunction = createWatchableFunction;
/*
  I tried to create a class that extends Map but TypeScript couldn't produce working runtime code.

  Returns a Map instance with extra methods to subscribe to operations:
    onClear(() => {}) - Add a callback for when map.clear is called.
    onDelete((key) => {}) - Add a callback for when a key is deleted.
    onSet((key, value) => {}) - Add a callback for when a key and value is set.

  All subscribe methods return an unsubscribe function.
*/
function createWatchableMap(entries) {
    var map = new Map(entries);
    var _a = __read(createWatchableFunction(map.clear), 2), clear = _a[0], onClear = _a[1];
    var _b = __read(createWatchableFunction(map.delete), 2), deleteMethod = _b[0], onDelete = _b[1];
    var _c = __read(createWatchableFunction(map.set), 2), set = _c[0], onSet = _c[1];
    return Object.assign(map, {
        clear: clear,
        onClear: onClear,
        delete: deleteMethod,
        onDelete: onDelete,
        set: function (key, value) {
            set.call(this, key, value);
            // Return the watchable map.
            return this;
        },
        onSet: onSet,
    });
}
exports.createWatchableMap = createWatchableMap;
//# sourceMappingURL=createWatchable.js.map